import * as React from "react";
import { AppTranslations } from "../../../../../components/Utils/translations/AppTranslations";
import { LoadingButton } from "../../../../../components/buttons/LoadingButton";
import { capitalizeFirstLetter, Icon } from "@vebox/etui-core";
import "./styles.scss";

declare var AppTranslations: AppTranslations;

interface SummaryCardFooterProps {
	onNext: () => void;
	disabled?: boolean;
	onExport: () => void;
	disableExport?: boolean;
	loading?: boolean;
	loadingExport?: boolean;
}

export const SummaryCardFooter: React.FC<SummaryCardFooterProps> = ({
	onNext,
	disabled,
	onExport,
	disableExport,
	loading,
	loadingExport,
}) => {
	return (
		<div className={"form-card-footer flx-row flx-space-between"}>
			<div className={"flx-row gap-15"}>
				<LoadingButton
					variant={"strong"}
					onClick={onExport}
					disabled={disableExport}
					loading={loadingExport}
				>
					<span className={"icon-button"}>
						<Icon symbol={"download"} weight={"400"} />
						{capitalizeFirstLetter(AppTranslations.miscellaneous.exportToExcel)}
					</span>
				</LoadingButton>
			</div>
			<div className={"flx-row gap-15"}>
				<LoadingButton
					variant={"strong"}
					onClick={onNext}
					disabled={disabled}
					loading={loading}
				>
					{AppTranslations.genericWords.homeButton}
				</LoadingButton>
			</div>
		</div>
	);
};
